export const CookieHelpers = {
  getCookie(cname: string) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  },
  setOptoutOfAlertCookie() {
    let expiration_date = new Date();
    let cookie_string = 'OptoutOfWarning';
    expiration_date.setFullYear(expiration_date.getFullYear() + 1);
    cookie_string =
      'OptoutOfWarning=true; path=/; expires=' + expiration_date.toUTCString();
    document.cookie = cookie_string;
  }
};
